<div
  class="input-group"
  [ngClass]="{
    inactive: !sideNavExpanded
  }"
>
  <input
    type="text"
    name="patientSearch"
    class="form-control border-0 grey-three-background"
    placeholder="{{ selectedFilter | titlecase }} Search"
    autocomplete="off"
    [formControl]="typeaheadControl"
    cdkOverlayOrigin
    #origin="cdkOverlayOrigin"
  />
  <i *ngIf="typeaheadLoading" class="far fa-spinner fa-lg loading-spinner"></i>
  <button (click)="showFilter = !showFilter" class="btn em-btn-green ml-1 px-1 white-font">
    <i class="fas fa-filter fa-sm"></i>
  </button>
</div>

<div *ngIf="showFilter" #patientFilterPanel id="patientFilterPanel">
  <div class="box">
    <div class="top-bar d-flex justify-content-end py-1">
      <button
        class="d-flex justify-content-center align-items-center px-0 py-0 btn pointer"
        (click)="showFilter = false"
      >
        <i class="fal fa-times"></i>
      </button>
    </div>
    <div class="container">
      <span class="flex-shrink-0">Filter By:</span>
      <mat-radio-group
        class="mr-2 d-flex flex-column"
        name="selectedSearchFilter"
        [(ngModel)]="selectedFilter"
        (change)="showFilter = false; typeaheadControl.setValue('')"
      >
        <mat-radio-button class="my-1 pr-2" value="name">Name</mat-radio-button>
        <mat-radio-button class="my-1 pr-2" value="email">Email</mat-radio-button>
        <mat-radio-button class="my-1 pr-2" value="phone">Mobile Phone</mat-radio-button>
      </mat-radio-group>
    </div>
  </div>
</div>

<ng-container *ngIf="typeaheadSource | async as patients">
  <ng-template
    *ngIf="typeaheadControl.value"
    cdkConnectedOverlay
    [cdkConnectedOverlayOrigin]="origin"
    [cdkConnectedOverlayOpen]="true"
    [cdkConnectedOverlayOffsetY]="4"
    [cdkConnectedOverlayHasBackdrop]="true"
    [cdkConnectedOverlayBackdropClass]="'cdk-overlay-transparent-backdrop'"
    (backdropClick)="typeaheadControl.setValue('')"
  >
    <div class="result-drop-down">
      <ng-scrollbar [autoHeightDisabled]="false" [autoWidthDisabled]="false">
        <ng-container *ngFor="let patient of patients">
          <button class="dropdown-item px-2">
            <div class="col d-flex">
              <input
                type="checkbox"
                class="mr-3 align-self-center"
                (change)="selectPatientCheckbox(patient.patientId, $event)"
                [checked]="selectedPatientIds.includes(patient.patientId)"
              />
              <div class="d-flex" (click)="selectPatient(patient.patientId)">
                <div class="d-inline pr-2">
                  <div [innerHTML]="formatResultString(patient)"></div>
                </div>
              </div>
            </div>
          </button>
        </ng-container>
      </ng-scrollbar>

      <div *ngIf="selectedPatientIds.length > 0" class="footer">
        <div class="mt-2 border"></div>
        <div class="d-flex justify-content-center m-2">
          <button class="btn em-btn em-btn-green" [disabled]="selectedPatientIds.length < 2" (click)="mergePatients()">
            <i class="fal fa-user-friends mr-1"></i>
            <span>Merge Patients</span>
          </button>
          <button class="btn em-btn em-btn-green ml-2" (click)="selectedPatientIds = []">
            <i class="fal fa-ban mr-1"></i>
            <span>Clear Selections</span>
          </button>
        </div>
      </div>
    </div>
  </ng-template>
</ng-container>
